import { metaAccount } from '@/router/meta-config'
const permissionKey = 'EVENT'
// TODO: HOTEL

export default [
  // hotels
  {
    path: '/hotels',
    name: 'page-hotels',
    component: () => import('@/pages/hotels'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/hotels/new',
    name: 'page-hotel-new',
    component: () => import('@/pages/hotel'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/hotels/:id',
    name: 'page-hotel',
    component: () => import('@/pages/hotel'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
